import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const getPaymentSchedule = (state) =>{

  return axios.get(API + "contracts/payment-edit/"+state+"/",{headers: authHeader(),});
};

const addPaymentSchedule = (state,amount, frequency,start_date,end_date,payment_type,no_of_payments,contract_id) => {
  return axios.post(API + "contracts/payment-edit/"+state+"/", {
    amount,
    frequency,
  start_date,
  end_date,
  payment_type,
  no_of_payments,
  contract_id
},{headers: authHeader(),});
};


const EditPaymentSService = {
    getPaymentSchedule,
    addPaymentSchedule,
};
export default EditPaymentSService;